module.exports = __webpack_public_path__ + "media/dog-personality-traits/toy-ball-b0ea18ef.svg";